import { useBackgroundReplication } from "./useBackgroundReplication"

export const BackgroundReplication = () => {
  useBackgroundReplication()

  return null
}
